import {ValueObject} from '@s-ui/domain'

import {BooleanSharedValueObject} from '../../shared/ValueObjects/BooleanSharedValueObject.js'

export class FilterBooleanSearchValueObject extends ValueObject {
  #boolean

  constructor({boolean}) {
    super()
    this.#boolean = boolean
  }

  static create({boolean}) {
    return new FilterBooleanSearchValueObject({boolean: BooleanSharedValueObject.create({value: boolean})})
  }

  get isEmpty() {
    return this.#boolean.value === null || this.#boolean.value === undefined
  }

  get value() {
    return this.#boolean.value
  }

  toJSON() {
    return {boolean: this.#boolean.toJSON()}
  }
}
